module.exports = __webpack_public_path__ + "static/img/pay-fr-btn.7b4e52a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/pay/pay-fr-btn.png
// module id = Aa2j
// module chunks = 1